<template>
    <el-dialog v-dialogDrag :visible.sync="show" :title="title"
               :close-on-click-modal="closeOnClickModal" :before-close="close"
               :close-on-press-escape="false" :append-to-body="true" :width="width">
        <slot>{{content}}</slot>
        <span slot="footer" v-show="!hideFooter">
            <slot name="footer">
                <el-button type="primary" @click="$emit('save')" icon="el-icon-check" :loading="loading">{{sureTxt}}</el-button>
                <el-button v-show="!hideCancel" style="margin-left: 25px;"
                           @click="cancel" :icon="cancelIcon">{{cancelTxt}}</el-button>
            </slot>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            // 是否隐藏底部按钮
            hideFooter: {
                type: Boolean,
                default: false
            },
            hideCancel: {
                type: Boolean,
                default: false
            },
            // 确定按钮文案
            sureTxt: {
                type: String,
                default: '确定'
            },
            // 取消按钮文案
            cancelTxt: {
                type: String,
                default: '取消'
            },
            cancelIcon: {
                type: String,
                default: 'el-icon-close'
            },
            //内部文本域
            content: {},
            // 如传true，会emit('cancel')
            isCancelEvent: {
                type: Boolean,
                default: false
            },
            // 按钮是否在加载中
            loading: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            width: {
                type: String,
                default: '50%'
            },
            show: {
                type: Boolean,
                default: false
            },
            closeOnClickModal: {
                type: Boolean,
                default: false
            },
            top: {
                type: String,
                default: '15vh'
            },
        },
        methods: {
            close() {
                this.$emit('update:show', false);
            },
            cancel() {
                if (this.isCancelEvent) {
                    this.$emit('cancel')
                } else {
                    this.close()
                }
            },
        }
    }
</script>